const OAUTH2_MACHINE_TO_MACHINE_FIELDS = [
  {
    key: 'clientId',
    name: 'Client ID',
    placeholder: 'Client ID',
    dataType: 'string',
    required: true,
    isSensitive: false
  },
  {
    key: 'clientSecret',
    name: 'Client Secret',
    placeholder: 'Client Secret',
    dataType: 'string',
    required: true,
    isSensitive: true
  }
];

const isMachineToMachineOAuth2Auth = (auth = {}) => {
  const normalizedType = String(auth?.type || '')
    .trim()
    .toLowerCase();
  const enableM2M = auth?.options?.enableM2M;

  return normalizedType === 'oauth2' && (enableM2M === true || enableM2M === 'true');
};

export const getOAuth2MachineToMachineFields = ({ auth, existingFields = [] } = {}) => {
  if (!isMachineToMachineOAuth2Auth(auth)) {
    return [];
  }

  const existingKeys = new Set(
    existingFields
      .map((field) =>
        String(field?.key || '')
          .trim()
          .toLowerCase()
      )
      .filter(Boolean)
  );

  return OAUTH2_MACHINE_TO_MACHINE_FIELDS.filter(
    (field) =>
      !existingKeys.has(
        String(field.key || '')
          .trim()
          .toLowerCase()
      )
  ).map((field) => ({ ...field }));
};
